<template>
    <div class="chart-body">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <div style="text-align:center;width: 33%;">
                    {{ this.$route.params.number + "#" }}
                </div>
                <div style="text-align:center;width: 33%;">今日机台信息</div>
                <!-- hongmj 追加选择日期 STA -->
                <div style="text-align:center;width: 20%;">可切换日期</div>
                <el-date-picker v-model="selectDay" type="date" placeholder="选择日" @change="changeDay" />
                <!-- hongmj 追加选择日期 END -->
                <div style="text-align:center;width: 33%;">
                    <el-button type="primary" @click="goBack()">返回</el-button>
                </div>
            </div>

            <el-descriptions class="margin-top" title="时序图" :column="1" :size="medium" :colon="false">
                <el-descriptions-item label="">
                    <div class="d1">
                        <span class="s1">运行</span>
                        <span class="s2">停机</span>
                        <span class="s3">盘头暂停</span>
                        <span class="s4">穿纱暂停</span>
                        <span class="s5">维修暂停</span>
                        <span class="s6">离线</span>
                    </div>

                    <machine-chart-state-line :chartData="canvasData" :drawStart="drawStart" />
                    <machine-time-axis />
                </el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" title="今日统计" :column="3" :size="medium">
                <el-descriptions-item v-if="this.kind == 0"
                    label="当前产量">{{ (machineState.weight / 1000).toFixed(2) }}kg</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 1"
                    label="当前产量">{{ machineState.heads }}个</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0"
                    label="当前米数">{{ (summary.todayLength / 100).toFixed(2) }}米</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0"
                    label="每小时产能">{{ (summary.weightPer / 1000).toFixed(2) }}kg</el-descriptions-item>
                <el-descriptions-item label="开机效率">{{
            summary.downTime == null
              ? "0"
              : (
                  (summary.todayRunTime /
                    (summary.todayRunTime + summary.downTime)) *
                  100
                ).toFixed(0)
          }}%</el-descriptions-item>
                <el-descriptions-item label="开机时长">{{
          timeChange(summary.todayRunTime)
        }}</el-descriptions-item>
                <el-descriptions-item label="停机时长">{{
          summary.downTime == null ? "0" : timeChange(summary.downTime)
        }}</el-descriptions-item>
                <el-descriptions-item label="停机次数">{{ summary.todayHaltCounts }}次</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0"
                    label="疵点个数">{{ summary.todayDefectCounts }}个</el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" title="班次信息" :column="3" :size="medium">
                <el-descriptions-item label="班次信息">早班</el-descriptions-item>
                <el-descriptions-item label="人员名字">{{
          workers.length == 0 ? "暂无数据" : workers[0].username
        }}</el-descriptions-item>
                <el-descriptions-item label="开机时长">{{
          workers.length == 0 ? "暂无数据" : timeChange(workers[0].totalTime)
        }}</el-descriptions-item>
                <el-descriptions-item label="开机效率">{{
          workers.length == 0
            ? "暂无数据"
            : (workers.totalTime / workers.validTime).toFixed(2) + "%"
        }}</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0" label="生产产能">{{
          workers.length == 0
            ? "暂无数据"
            : workers[0].finishedWeight / 1000 + "kg"
        }}</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0" label="生产米数">{{
          workers.length == 0
            ? "暂无数据"
            : workers[0].finishedMeter / 100 + "米"
        }}</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0" label="停机次数">{{
          workers.length == 0 ? "暂无数据" : workers[0].machineStopCount + "次"
        }}</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0" label="缺陷个数">{{
          workers.length == 0 ? "暂无数据" : workers[0].detectCount + "个"
        }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" title="设备参数" :column="3" :size="medium">
                <el-descriptions-item v-if="this.kind == 1"
                    label="盘头周长">{{ warpMachine.perimeter }}mm</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0"
                    label="设置密度">{{ param.userDensity / 100 }}M/cm</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0"
                    label="实时密度">{{ param.realDensity / 100 }}M/cm</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0"
                    label="机台油温">{{ param.temperature }}°c</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0"
                    label="设置布长">{{ param.userClothLength / 100 }}米</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0"
                    label="当前布长">{{ param.realClothLength / 100 }}米</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0" label="落布时间">{{
          timeChange(param.leftDownCloth)
        }}</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 1"
                    label="设置米数">{{ warpMachine.userMeter / 100 }}米</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 1"
                    label="设置圈数">{{ warpMachine.userTurns }}R</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 1"
                    label="实际圈数">{{ warpMachine.realTurns }}R</el-descriptions-item>
                <el-descriptions-item label="设置转速">{{ param.userSpeed }}转/分钟</el-descriptions-item>
                <el-descriptions-item label="实际转速">{{ param.realSpeed }}转/分钟</el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" title="工单信息" :column="3" :size="medium">
                <el-descriptions-item label="当前产品">{{
          order.name
        }}</el-descriptions-item>
                <el-descriptions-item label="工单编号">{{
          order.orderNumber
        }}</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0" label="当前进度">
                    <el-progress :percentage="getProgress(order.orderFinishLenth, order.orderLenth)"></el-progress>
                </el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 1" label="当前进度">
                    <el-progress :percentage="getProgress(order.orderFinishHeads, order.orderHeads)"></el-progress>
                </el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 1" label="盘头个数">{{
          order.orderHeads
        }}</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 1" label="已完成">{{
          order.orderFinishedHeads
        }}</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 1" label="当前制作">{{
          order.orderNumber
        }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" title="盘头信息" :column="3" :size="medium" :colon="false"
                v-if="this.kind == 0">
                <el-descriptions-item>
                    <el-table :data="GBInfos" style="width: 100%" border>
                        <el-table-column prop="name" label="GB" width="width" align="center"></el-table-column>
                        <el-table-column prop="perimeter" label="当前周长" width="width" align="center"></el-table-column>
                        <el-table-column prop="turns" label="当前圈数" width="width" align="center"></el-table-column>
                        <el-table-column label="剩余时间" width="width" align="center">
                            <template slot-scope="scope">
                                {{ timeChange(scope.row.leftTime) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="warp" label="当前送经量" width="width" align="center"></el-table-column>
                        <el-table-column prop="meterial" label="原料" width="width" align="center"></el-table-column>
                        <el-table-column prop="meterialRation" label="纱线占比" width="width"
                            align="center"></el-table-column>
                        <el-table-column prop="meterialPer" label="每小时用量" width="width"
                            align="center"></el-table-column>
                    </el-table>
                </el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" title="预警信息" :column="3" :size="medium">
                <el-descriptions-item label="转速偏离预警">{{ orderData.speedThreshold }}%</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0"
                    label="送经量偏离预警">{{ orderData.feedThreshold }}%</el-descriptions-item>
                <el-descriptions-item v-if="this.kind == 0"
                    label="盘头剩余时长预警">{{ orderData.leftTimeThreshold }}小时</el-descriptions-item>
            </el-descriptions>
        </el-card>
    </div>
</template>

<script>
    import * as api from "@/api/factory/dashboard";
    import chartObj from "./static/chartObj.js";
    import machineTimeAxis from "./components/machineTimeAxis.vue";
    import machineChartStateLine from "./components/machineChartStateLine.vue";
    export default {
        name: "machineChart",
        components: {
            machineChartStateLine,
            machineTimeAxis,
        },
        data() {
            return {
                selectDay: '', //hongmj 追加选择日期
                today: "",
                machineStateColor: chartObj.machineStateColor,
                canvasData: [],
                canvasTime: [],
                drawStart: 0,
                todayCanvasData: [],
                todayDrawStart: 0,
                machineState: {},
                GBInfos: [],
                workers: [],
                orderData: [],
                summary: {},
                param: {},
                order: {},
                kind: "",
                warpMachine: {},
            };
        },
        created() {
            //hongmj 追加选择日期 sta
            const now = new Date().getTime()
            this.selectDay = now
            //hongmj 追加选择日期 end
            this.getDetailList();
            this.getWorkOrderByMachineId();
            this.kind = this.$route.params.kind;
            console.log(this.kind);
        },
        mounted() {
            let timesDay1 = this.getTimes(0);
            console.log(timesDay1);
            this.getStateCanvasData(timesDay1);
            console.log(this.workers);
        },
        methods: {
            getDetailList() {
                return api
                    .getDetailList({
                        machineId: this.$route.params.id
                    })
                    .then((res) => {
                        console.log(res);
                        this.machineState = res.data.machineState[0];
                        this.GBInfos = res.data.machineState[0].GBInfos;
                        this.workers = res.data.machineState[0].workers;
                        this.summary = res.data.machineState[0].summary;
                        this.param = res.data.machineState[0].param;
                        this.order = res.data.machineState[0].order;
                        if (this.kind == 1) {
                            this.warpMachine = res.data.machineState[0].warpMachine;
                        }
                    });
            },
            getWorkOrderByMachineId() {
                console.log(111);
                return api
                    .getWarn({
                        machineIds: [this.$route.params.id]
                    })
                    .then((res) => {
                        console.log(res);
                        this.orderData = this.formatResponse(res.data[0]);
                    });
            },
            // 格式化工单信息
            formatResponse(res) {
                res.speedThreshold = res.speedThreshold;
                res.feedThreshold = res.feedThreshold;
                res.leftTimeThreshold = res.leftTimeThreshold;
                return res;
            },
            getProgress(val1, val2) {
                if (val1 == null || val2 == null) {
                    return 0;
                }
                return ((val1 / val2) * 100).toFixed(0);
            },
            goBack() {
                this.$router.push("/product/machinePreview");
            },
            timeChange(input) {
                // input = 4 / 3 //调试时候打开它
                // input = 60 *  12 / 11 //调试时候打开它
                // input = 60 * 60 * 12 / 11 //调试时候打开它
                // input = 60 * 60 * 24 * 4 / 3 //调试时候打开它
                let outputString = "";

                if (input == null || input == undefined) {
                    return (outputString = "无");
                }

                if (input < 60) {
                    outputString = input.toFixed(2) + "秒";
                } else if (input >= 60 && input < 60 * 60) {
                    outputString =
                        Math.trunc(input / 60) + "分" + (input % 60).toFixed(0) + "秒";
                } else if (input >= 60 * 60 && input < 60 * 60 * 24) {
                    outputString = (input / (60 * 60)).toFixed(2) + "小时";
                } else {
                    outputString =
                        Math.trunc(input / (60 * 60 * 24)) +
                        "天" +
                        (input / (60 * 60 * 24) - Math.trunc(input / (60 * 60 * 24))).toFixed(
                            2
                        ) +
                        "小时";
                }
                return outputString;
            },
            // 获取0点的时间戳
            getTimes(day) {
                let times = new Date(
                    new Date().setHours(0, 0, 0, 0) - day * 24 * 60 * 60 * 1000
                );
                return times * 1;
            },
            // 获取时序图的数据
            getStateCanvasData(timestamp) {
                const params = {
                    machineId: this.$route.params.id,
                    time: timestamp,
                };
                api.getStateCanvasData(params).then((res) => {
                    if (this.utils.isEmpty(res.data)) {
                        this.canvasData = [];
                        this.drawStart = 0;
                        return;
                    }
                    const response = this._.sortBy(res.data, (obj) => {
                        return Number(obj.time);
                    });
                    const firstChange = Number(response[0].time);
                    const drawStart = (
                        (firstChange - this.utils.getDayStart(firstChange)) /
                        86400000
                    ).toFixed(2);
                    const formatData = this.formatStateCanvasData(response);
                    if (this.utils.isToday(timestamp)) {
                        if (this.utils.isEmpty(this.canvasData)) {
                            this.canvasData = formatData;
                            this.drawStart = drawStart;
                        }
                        this.todayCanvasData = formatData;
                        this.todayDrawStart = drawStart;
                    } else {
                        this.canvasData = formatData;
                        this.drawStart = drawStart;
                    }
                });
            },
            // 格式化时序图的数据
            formatStateCanvasData(response) {
                const formArray = [];
                const resLen = response.length - 1;

                response.forEach((obj, index) => {
                    if (index === resLen) {
                        return;
                    }
                    const nextObj = response[index + 1];
                    const value = ((nextObj.time - obj.time) / 86400000).toFixed(4);
                    if (value === 0.0) {
                        return;
                    }
                    const formatObj = {};
                    formatObj.state = obj.state;
                    formatObj.stateTime = nextObj.time - obj.time;
                    formatObj.color = this.machineStateColor[obj.state];
                    formatObj.value = value;
                    formArray.push(formatObj);
                });
                return formArray;
            },
            
            // 切换日期
            changeDay(val) {
                const selectTime = val.getTime()
                // console.log(selectTime);
                this.getStateCanvasData(selectTime);
            },
        },
    };
</script>

<style scoped lang="scss">
    /deep/ .el-descriptions-item__container {
        display: block;
    }

    /deep/ .el-descriptions-item__container {
        font-size: 18px;
    }

    .chart-body {
        padding: 10px 10px 0px 10px;
    }

    .clearfix {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 30px;
    }

    .d1 span {
        display: inline-block;
        width: 120px;
        height: 26px;
        text-align: center;
        margin-right: 10px;
        margin-bottom: 6px;
        color: #fff;
    }

    .s1 {
        background-color: #19be6b;
    }

    .s2 {
        background-color: #f29100;
    }

    .s3 {
        background-color: #8400ff;
    }

    .s4 {
        background-color: #00bfbf;
    }

    .s5 {
        background-color: #d9001b;
    }

    .s6 {
        background-color: #aaaaaa;
    }
</style>